<template>
  <div class="bookstore-detail">

    <div class="book-introduction">
      <div class="left-demo-card">
        <div class="left-demo-body">
          <div class="left-img-box flex-center">
            <img :src="coverFiles.length > 0 ? coverFiles[currImg].fullUrl : ''" alt="" />
          </div>
          <div class="left-small-img">
            <img v-for="(item, index) in coverFiles" :key="index + Math.random()" :src="item.fullUrl"
              :class="index == currImg ? 'demo-card-box-img-checked' : ''" @click="changeSrc(index)" alt="" />
          </div>
        </div>
      </div>
      <div class="right-info">
        <div class="title">
          <div class="book-label">
            {{ callDictionaries(goodsTypeList, goodsInfo.resourceType) }}
          </div>
          <span>{{ goodsInfo.goodsTitle }}</span>
        </div>
        <div class="book-intro" v-if="goodsInfo.authorRecommendation">
          <div class="defaultIntro" @mouseenter="enterShow" @mouseleave="leaveShow">
            <span class="twointro">{{ goodsInfo.authorRecommendation | ellipsis(120) }}
              <span class="font" v-if="goodsInfo.authorRecommendation.length > 120">更多</span></span>
            <div v-if="showMore" class="allIntro">
              <span>{{ goodsInfo.authorRecommendation }}</span>
            </div>
          </div>
        </div>
        <div class="label">
          <span v-for="(item, index) in keyword" :key="index">{{ item }}</span>
        </div>
        <div class="book-intro-info">
          <div v-if="goodsInfo.goodsType == 'paper'">
            <span>教学属性：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.teachPropertyAllStr == null ||
                goodsInfo.teachPropertyAllStr == ""
                ? "-"
                : goodsInfo.teachPropertyAllStr
            }}</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper'">
            <span>学科：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.subjectName == null || goodsInfo.subjectName == ""
                ? "-"
                : goodsInfo.subjectName
            }}</span>
          </div>
          <div v-if="goodsInfo.goodsType == 'paper'">
            <span>考试时长：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.timeCount == null || goodsInfo.timeCount == ""
                ? "-"
                : goodsInfo.timeCount
            }}分钟</span>
          </div>
        </div>
        <div class="book-intro-info">
          <div>
            <span>题目数量：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.questionCount == null || goodsInfo.questionCount == ""
                ? "-"
                : goodsInfo.questionCount
            }}</span>
          </div>
          <div>
            <span>满分：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.fullScore == null || goodsInfo.fullScore == ""
                ? "-"
                : goodsInfo.fullScore
            }}分</span>
          </div>
          <div>
            <span>及格分：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.passingScore == null || goodsInfo.passingScore == ""
                ? "-"
                : goodsInfo.passingScore
            }}分</span>
          </div>
        </div>
        <div style="
            width: 100%;
            height: 2px;
            background: #f2f2f2;
            margin-top: 30px;
          "></div>
        <div class="buttons">
          <el-button type="primary" @click="answer">在线考试</el-button>
        </div>
      </div>
    </div>
    <supportingRoll />


    <div class="table_list xml-el-tabs-paper-box">
      <el-tabs v-model="activeName">
        <el-tab-pane label="自测历史" name="first">
          <answeringHistory v-if="activeName == 'first'" :paperId="goodsInfo.paperId" :goodsId="goodsId"
            @upTotal="(e) => { this.total = e }" />
        </el-tab-pane>
        <el-tab-pane label="配套卷答题历史" name="second">
          <answeringHistory v-if="activeName == 'second'" isEquip="1" paperType="peitaojuan" :goodsId="goodsId"
            @upTotal="(e) => { this.total = e }" />
        </el-tab-pane>
      </el-tabs>
      <div class="total-box">答题次数：{{ total }}</div>
    </div>
  </div>
</template>
<script>
import {
  goodsInfoDetail,
  checkIsBuy,
  SelGoodsStatus,
  teachingAttrList,
  isHavingPermissions,
} from "@/api/bookstore/bookstore";
import { getAnswerPaperRecord, getAnswerPaperGpa } from "@/api/answer/answer";
import { paperGetToken } from "@/api/index/index";
import supportingRoll from '../components/supportingRoll.vue'
import answeringHistory from '../components/answeringHistory.vue'
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      subjectId: null,
      difen: "",
      showMore: false,
      sourceList: "",
      keyword: [],
      goodsId: null,
      goodsType: null,
      goodsInfo: {}, //商品基本信息
      currImg: 0,
      coverFiles: [], //左侧商品图片数组
      authorList: [], //作者简介
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        answerPlatform: "",
        paperId: "",
        userId: "",
        token: "",
        params1: "",
      },
      total: 0,
      goodsTypeList: [],
      tableData: [],
      robotBook: [
        "1613418196050776064",
        "1613418196050776064",
        "1689873142887092224",
      ],

      bookName: "",
      activeName: "first"
    };
  },
  computed: {
    ...mapGetters(["threeUserInfo"]),
  },
  components: { supportingRoll, answeringHistory },
  created() {
    this.$store.commit("subjectId_book", this.$route.query.goodsId);
    this.goodsId = this.$route.query.goodsId;
    this.goodsType = this.$route.query.goodsType;
    this.subjectId = this.$route.query.subjectId;
    this.queryParams.userId = this.$store.state.user.userId;
    this.getList();
    this.getoc_resource_file();
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.goodsId) {
        this.$store.commit("subjectId_book", this.$route.query.goodsId);
        this.goodsId = this.$route.query.goodsId;
        this.goodsType = this.$route.query.goodsType;
        this.getList();
      }
    },
  },
  methods: {
    enterShow() {
      if (this.goodsInfo.authorRecommendation.length > 135) {
        this.showMore = true;
      }
    },
    leaveShow() {
      this.showMore = false;
    },
    // render 事件
    useTimeHeader(h, { column }) {
      return h("div", [h("span", column.label), h("span", this.total)]);
    },
    // render 事件
    answerScoreHeader(h, { column }) {
      return h("div", [h("span", column.label), h("span", this.difen + "分")]);
    },
    getTime(time) {
      let m = parseInt(time / 60);
      let s = time % 60;
      let date = (m > 9 ? m : "0" + m) + "分" + (s > 9 ? s : "0" + s) + "秒";
      return date;
    },
    getList() {
      //商品基本信息
      goodsInfoDetail(this.goodsId).then((res) => {
        if (res.code == 200) {
          this.goodsInfo = res.data.goods;
          this.bookName = res.data.goods.goodsTitle;
          this.sourceList = res.data.sourceList[0];
          if (this.goodsInfo.keyword) {
            this.keyword = this.goodsInfo.keyword.split(",");
          }
          this.coverFiles = res.data.coverFiles;
          if (this.coverFiles.length == 0) {
            let data = {
              fullUrl: require("@/assets/images/default_img.jpg"),
            };
            this.coverFiles.push(data);
          }
          let xiaoZhi = res.data.xiaoZhi;
          // 小智信息存本地
          if (xiaoZhi && xiaoZhi != {}) {
            localStorage.setItem("xiaoZhi", JSON.stringify(res.data.xiaoZhi));
          }
        }
      });
    },

    changeSrc(index) {
      this.currImg = index;
    },

    getoc_resource_file() {
      //来源
      teachingAttrList("oc_resource_file").then((res) => {
        this.goodsTypeList = res.data;
      });
    },
    //开始考试
    answer() {
      if (this.threeUserInfo.userId) {
        this.goAnswer()
        return
      }

      isHavingPermissions({
        goodsFileId: this.sourceList.goodsId,
        fileType: this.sourceList.fileType,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {
        if (res.data.hasPermission) {
          //有权限
          this.goAnswer()
        } else {
          //无权限走购买流程
          this.$alert("该文件需要购买后才能阅读，是否确认购买", "购买", {
            confirmButtonText: "立即购买",
            callback: (action) => {
              if (action === "cancel") {
                return;
              }
              let userId = this.$store.getters.userId;
              if (!userId) {
                this.$store.commit("SET_REDIRECTPARAMS", {
                  goodsId: this.$route.query.goodsId,
                  relevanceId: this.$route.query.relevanceId,
                  resource: this.$route.query.resource,
                  resourceType: this.$route.query.resourceType,
                });
                this.$router.push({
                  path: "/login",
                  query: {
                    redirectPath: "/bookstore/answer",
                  },
                });
              } else {
                //判断是否购买该商品
                this.payType = this.$route.query.payType
                  ? this.$route.query.payType
                  : "goods";
                checkIsBuy({
                  relevanceId: this.$route.query.goodsId,
                  type: this.payType,
                }).then((res) => {
                  console.log("是否已购买响应", res);
                  if (res.data === "2") {
                    this.$message.error("数据异常");
                    return;
                  }
                  if (res.data === "1") {
                    this.$router.push({
                      path: "/submitOrder/index",
                      query: {
                        id: this.$route.query.goodsId,
                        from: "bookstore",
                      },
                    });
                  } else {
                    this.$message("该商品已购买无需重复购买");
                  }
                });
              }
            },
          });
        }
      });
    },
    // 跳转答题
    goAnswer() {
      this.$router.push({
        path: "/bookstore/examination",
        query: {
          testPaperId: this.goodsInfo.paperId,
          userId: this.$store.state.user.userId,
          userName: this.$store.state.user.name,
          goodsId: this.$route.query.goodsId,
          fromType: "/user/myResources",
          bookName: this.bookName,
          showAi:
            JSON.stringify(this.robotBook).indexOf(
              this.$route.query.goodsId
            ) !== -1
              ? true
              : false,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.bookstore-detail {
  width: 1400px;
  height: auto;
  margin: 0 auto;
  padding-bottom: 40px;

  .book-introduction {
    display: flex;
    width: 100%;
    min-height: 452px;
    background: #fffefd;
    margin: 0 auto 16px;
    box-sizing: border-box;
    padding: 20px 25px;

    .left-demo-card {
      margin-right: 67px;
      width: 380px;

      .left-demo-body {
        width: 380px;
        height: 380px;
        background: #fff;
        border: 1px solid #f2f2f2;

        .left-img-box {
          width: 280px;
          height: 280px;
          background: #fbfbfb;
          margin: 5px auto 15px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .left-small-img {
          display: grid;
          grid-column-gap: 5px;
          grid-template-columns: repeat(5, calc(20% - 4px));
          box-sizing: border-box;
          padding: 0 12px;

          img {
            width: 61px;
            height: 61px;
            object-fit: scale-down;
            background: #fbfbfb;
          }

          .demo-card-box-img-checked {
            border: 1px solid #1890ff;
          }
        }
      }

      .left-demo-bottom {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
          cursor: pointer;

          img {
            margin-right: 5px;
          }

          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .right-info {
      width: 900px;
      overflow: hidden;

      .title_info {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        padding-bottom: 20px;
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .book-label {
          padding: 0 5px;
          height: 24px;
          background: #f9fdff;
          margin-right: 7px;
          border: 1px solid #0081ce;
          border-radius: 6px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          line-height: 24px;
          text-align: center;
        }

        span {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: black;
          font-weight: bold;
        }
      }

      .book-intro {
        line-height: 20px;
        margin-bottom: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;

        .defaultIntro {
          position: relative;
          padding: 10px;
          box-sizing: border-box;
        }

        .allIntro {
          position: absolute;
          left: 0;
          top: 0;
          background: #fffefd;
          z-index: 999;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 10px;
          box-sizing: border-box;
        }

        .font {
          color: #2e9adb;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .label {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-wrap: wrap;

        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          background: #f2f2f2;
          border-radius: 6px;
          padding: 7px 10px;
          margin-right: 16px;
          box-sizing: border-box;
          display: block;
          margin-bottom: 8px;
        }

        span:last-child {
          margin-right: 0;
        }
      }

      .book-intro-info {
        width: 850px;
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        >div {
          flex: 1;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          align-items: center;
        }

        >div:nth-of-type(1) {
          span:last-child {
            width: 200px;
          }
        }

        >div:nth-of-type(2) {
          span:last-child {
            width: 200px;
          }
        }

        >div:nth-of-type(3) {
          span:last-child {
            width: 200px;
          }
        }
      }

      .buttons {
        margin-top: 30px;
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .bookstore-detail {
    width: calc(100% - 30px);

    .book-introduction {
      .right-info {
        width: calc(100% - 380px);
      }
    }
  }
}

.table_list {
  width: 100%;
  margin: 0 auto;
}

.pagination-box {
  text-align: right;
  background: #fffefd;
  padding: 25px 0;
}

.underline {
  // font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  text-decoration: underline;
  color: #2e9adb;
  line-height: 17px;
  cursor: pointer;
}
</style>